import PermissionPages from './PermissionPages';

export default PermissionPages;
